import React from "react"
import useSearchParamStore from "../../../stores/SearchParamStore"
import useStyles from "../../styles"
import DefaultButton from "../../../components/DefaultButton"
import { Plus } from "lucide-react"
import { SearchHeader } from "../../../components/SearchHeader"
import { Button } from "@material-ui/core"

const AnnouncementsLayout = () => {
  const { searchParam, setSearchParam, setOpenModal } = useSearchParamStore()
  const classes = useStyles()

  const handleOpenTagModal = () => {
    setOpenModal(true)
  }

  return (
    <div className={classes.buttonContainer}>
      <Button
        className={classes.buttonNova}
        variant="contained"
        color="primary"
        disableElevation
        startIcon={<Plus />}
        onClick={handleOpenTagModal}
      >
        Novo
      </Button>
      <SearchHeader searchParam={searchParam} setSearchParam={setSearchParam} placeholder={"Pesquisar..."} />
    </div>
  )
}

export default AnnouncementsLayout
